var Handlebars = require("/home/rod/work/mySVN/netball/client/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\">  \n    <div class=\"col-md-12\"><form method=\"post\" class=\"form-horizontal\" onsubmit=\"return false;\"> \n    <div class=\"form-group\"> \n        <label class=\"col-md-4 control-label\" for=\"password\">Password:</label> \n        <div class=\"col-md-4\"> \n        <input id=\"password\" name=\"password\" type=\"password\" placeholder=\"\" class=\"form-control input-md\">\n        </div>  \n    </div>     \n    </form></div>  \n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/dialogPW.handlebars
 ** module id = 62
 ** module chunks = 1
 **/